import { createSlice } from "@reduxjs/toolkit";

const initialModuleState = {
  enabledModules: {},
  loadingModules: true,
};

const modules = createSlice({
  name: "modules",
  initialState: initialModuleState,
  reducers: {
    setModules(state, action) {
      state.loadingModules = false;
      state.enabledModules = action.payload;
    },
  },
});
export const moduleActions = modules.actions;
export default modules.reducer;
